export default __webpack_public_path__ + "static/media/logo.ac0c8380.jpg";